import ReviewsWidget from '@components/ui-components/builder/widget/reviews/component.js'
import VendorsWidget from '@components/ui-components/builder/widget/vendors/component.js'
import CasesWidget from '@components/ui-components/builder/widget/cases/component.js'
import ServicesSelectionWidget from '@components/ui-components/builder/widget/services-selection/component.js'
import ServicesHighlightWidget from '@components/ui-components/builder/widget/services-highlight/component.js'
import AxoftTodayWidget from '@components/ui-components/builder/widget/axoft-today/component.js'
import SolutionsSelectionWidget from '@components/ui-components/builder/widget/solutions-selection/component.js'
import CaseSolutionsWidget from '@components/ui-components/builder/widget/case-solutions/component.js'

export default {
  components: {
    'reviews-widget': ReviewsWidget, // Отзывы
    'vendors-widget': VendorsWidget, // Вендоры
    'cases-widget': CasesWidget, // Кейсы
    'services-selection-widget': ServicesSelectionWidget, // Сервисы. Выбор записей
    'services-highlight-widget': ServicesHighlightWidget, // Сервисы. Зеленый блок
    'axoft-today-widget': AxoftTodayWidget, // Axoft сегодня
    'solutions-selection-widget': SolutionsSelectionWidget, // Подбор решений
    'case-solutions-widget': CaseSolutionsWidget, // Решения этого кейса
  },
  data() {
    return {}
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/widget/component.js